export default function initWidgets() {
  const widget = document.querySelector("[data-widget]");
  if (!widget) return;

  // 1. Используем throttle для оптимизации производительности
  const trackScroll = () => {
    const shouldShow = window.scrollY > 300;
    widget.style.opacity = shouldShow ? "1" : "0";
  };

  // 2. Добавляем throttle (не даем событию срабатывать слишком часто)
  let ticking = false;
  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        trackScroll();
        ticking = false;
      });
      ticking = true;
    }
  };

  trackScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  // 3. Проверяем наличие всех элементов
  const btn = document.querySelector("[data-cookies-btn]");
  const cookies = document.querySelector(".widgets__widget-cookie");

  if (!btn || !cookies) return;

  // 4. Проверяем cookies сразу
  const isCookiesAccepted = localStorage.getItem("cookies-widget");
  if (isCookiesAccepted !== null) {
    cookies.style.display = "none";
  }

  btn.addEventListener("click", () => {
    localStorage.setItem("cookies-widget", "true");
    cookies.style.display = "none";
  });
}
